export const isStartPage = (page) => {
    return page.contentType[1] === 'StartPage';
};
